
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy-and-sell",
      function () {
        return require("private-next-pages/buy-and-sell/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buy-and-sell"])
      });
    }
  